import { render, staticRenderFns } from "./HomeCa.vue?vue&type=template&id=2fc7389e&"
import script from "./HomeCa.vue?vue&type=script&lang=js&"
export * from "./HomeCa.vue?vue&type=script&lang=js&"
import style0 from "./HomeCa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports